
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"18.98"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M7.921 18.981c-.944 0-2.912-1.623-4.679-3.859C.316 11.422 0 8.909 0 7.999a8 8 0 0116 0 8.394 8.394 0 01-.988 3.58 19.459 19.459 0 01-2.312 3.566c-1.79 2.221-3.765 3.832-4.7 3.832a.947.947 0 01-.079.004zm.082-13.98a2 2 0 102 2A2 2 0 008 5z"}}),_c('path',{attrs:{"d":"M7.92 18.48l.045-.001.037-.002c.553 0 2.304-1.159 4.308-3.647.926-1.148 1.705-2.35 2.253-3.47.622-1.274.937-2.405.937-3.362C15.5 3.863 12.137.5 8.002.5 3.866.5.5 3.863.5 7.998c0 .858.305 3.236 3.134 6.813.834 1.054 1.748 2.011 2.574 2.693.873.72 1.458.977 1.713.977M8.002 4.5a2.502 2.502 0 012.5 2.498c0 1.379-1.122 2.5-2.5 2.5a2.502 2.502 0 01-2.5-2.5 2.502 2.502 0 012.5-2.498m-.081 14.48c-.944 0-2.912-1.623-4.679-3.859C.316 11.421 0 8.908 0 7.998 0 3.588 3.59 0 8.002 0 12.412 0 16 3.588 16 7.998c0 1.033-.333 2.238-.988 3.58-.565 1.156-1.364 2.389-2.312 3.567-1.79 2.22-3.765 3.832-4.698 3.832a1.1 1.1 0 01-.081.004zM8.002 5c-1.102 0-2 .897-2 1.998 0 1.104.898 2 2 2a2.001 2.001 0 002-2 2.001 2.001 0 00-2-1.998z","fill":"#bebebe"}})])])
          )
        }
      }
    